import React from "react";
import { Link } from "react-router-dom";
import LegalLayout, { Section } from "./LegalLayout";

const email = "support@velisproductivity.com";
const Email = () => (
  <a className="text-velis-orange" href={`mailto:${email}`}>
    {email}
  </a>
);

const PrivacyLink = () => (
  <Link className="text-velis-orange" to="/confidentialite">
    Politique de confidentialité
  </Link>
);

const Terms = () => (
  <LegalLayout title="Conditions d’utilisation" updated="Août 2026">
    <p>
      En utilisant VÉLIS, vous acceptez les présentes conditions d’utilisation. Si vous n’acceptez pas
      ces conditions, veuillez ne pas utiliser l’application.
    </p>

    <Section heading="1. Objet du service">
      <p>
        VÉLIS est une application de productivité permettant notamment d’organiser des missions, de
        définir des priorités, de créer des expéditions et de suivre sa progression.
      </p>
      <p>
        VÉLIS est un outil d’organisation personnelle. Les décisions prises à partir de l’utilisation de
        l’application demeurent sous votre responsabilité.
      </p>
    </Section>

    <Section heading="2. Compte utilisateur">
      <p>Certaines fonctionnalités de VÉLIS nécessitent la création d’un compte.</p>
      <p>Vous êtes responsable :</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>de fournir des informations exactes lors de la création de votre compte;</li>
        <li>de préserver la confidentialité de vos identifiants;</li>
        <li>des activités effectuées à partir de votre compte.</li>
      </ul>
      <p>
        Si vous soupçonnez un accès non autorisé à votre compte, veuillez nous contacter à : <Email />
      </p>
    </Section>

    <Section heading="3. Vos contenus et vos données">
      <p>
        Vous demeurez responsable des missions, expéditions, notes, priorités et autres contenus que
        vous créez dans VÉLIS.
      </p>
      <p>
        Les données nécessaires au fonctionnement de VÉLIS sont associées à votre compte afin de
        permettre leur sauvegarde et leur récupération lors de vos prochaines utilisations.
      </p>
      <p>
        Le traitement de vos renseignements personnels est décrit plus en détail dans notre <PrivacyLink />.
      </p>
    </Section>

    <Section heading="4. Utilisation acceptable">
      <p>
        Vous vous engagez à utiliser VÉLIS de façon légale et conformément à sa destination.
      </p>
      <p>Il est notamment interdit de :</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>tenter d’accéder sans autorisation aux systèmes ou comptes d’autres utilisateurs;</li>
        <li>perturber ou compromettre le fonctionnement ou la sécurité du service;</li>
        <li>utiliser VÉLIS à des fins frauduleuses, illégales ou abusives;</li>
        <li>
          copier, modifier, décompiler ou tenter d’extraire le code de l’application, sauf lorsque la loi
          l’autorise expressément.
        </li>
      </ul>
    </Section>

    <Section heading="5. Propriété intellectuelle">
      <p>
        VÉLIS, sa marque, son identité visuelle, son interface, son design, ses textes, illustrations,
        éléments graphiques et autres contenus protégés demeurent la propriété de leurs titulaires
        respectifs.
      </p>
      <p>Aucun droit de propriété sur VÉLIS ne vous est transféré par votre utilisation de l’application.</p>
      <p>
        Toute reproduction ou utilisation non autorisée des éléments protégés est interdite, sous réserve
        des droits prévus par la loi.
      </p>
    </Section>

    <Section heading="6. Fonctionnalités gratuites et contenus payants">
      <p>VÉLIS peut offrir gratuitement certaines fonctionnalités.</p>
      <p>
        Des fonctionnalités, contenus, packs ou options supplémentaires peuvent également être proposés
        moyennant paiement.
      </p>
      <p>Le prix et les conditions applicables sont affichés avant tout achat.</p>
      <p>
        Lorsque l’achat est effectué par l’intermédiaire de l’App Store, le paiement, la facturation et
        les remboursements sont également soumis aux règles applicables d’Apple et aux lois en vigueur.
      </p>
    </Section>

    <Section heading="7. App Store">
      <p>
        Lorsque VÉLIS est téléchargée depuis l’App Store, votre utilisation de l’application est également
        soumise aux conditions et au contrat de licence applicables d’Apple.
      </p>
      <p>
        Les présentes conditions complètent ces règles sans limiter les droits dont vous bénéficiez en
        vertu des conditions d’Apple ou des lois applicables.
      </p>
    </Section>

    <Section heading="8. Disponibilité et modifications du service">
      <p>
        Nous pouvons faire évoluer VÉLIS afin d’améliorer l’application, corriger des problèmes, ajouter
        ou modifier des fonctionnalités ou assurer la sécurité du service.
      </p>
      <p>
        Nous cherchons à maintenir VÉLIS accessible et fonctionnelle, mais nous ne pouvons garantir une
        disponibilité continue ou sans interruption.
      </p>
      <p>
        Certaines fonctionnalités peuvent être modifiées, suspendues ou retirées lorsque cela est
        raisonnablement nécessaire.
      </p>
    </Section>

    <Section heading="9. Suppression ou suspension du compte">
      <p>Vous pouvez supprimer votre compte directement depuis VÉLIS.</p>
      <p>
        Nous pouvons suspendre ou limiter l’accès à un compte en cas d’utilisation frauduleuse, abusive,
        illégale ou présentant un risque pour la sécurité du service ou de ses utilisateurs.
      </p>
      <p>
        Lorsqu’un compte est supprimé, les données qui lui sont associées sont traitées conformément à
        notre <PrivacyLink /> et aux obligations légales applicables.
      </p>
    </Section>

    <Section heading="10. Limitation de responsabilité">
      <p>VÉLIS est fourni comme outil de productivité et d’organisation personnelle.</p>
      <p>
        Dans la mesure permise par la loi, nous ne sommes pas responsables des pertes indirectes
        découlant de l’utilisation ou de l’impossibilité d’utiliser VÉLIS.
      </p>
      <p>
        Aucune disposition des présentes conditions ne limite les droits, garanties ou recours dont vous
        bénéficiez obligatoirement en vertu des lois applicables en matière de protection du consommateur.
      </p>
    </Section>

    <Section heading="11. Protection des renseignements personnels">
      <p>
        L’utilisation de VÉLIS est soumise à notre <PrivacyLink />, qui explique notamment
        les renseignements recueillis, leur utilisation, leur conservation ainsi que vos droits.
      </p>
    </Section>

    <Section heading="12. Modifications des présentes conditions">
      <p>
        Nous pouvons mettre à jour les présentes conditions afin de refléter les changements apportés à
        VÉLIS, à nos pratiques ou aux exigences légales.
      </p>
      <p>La date de la dernière mise à jour est indiquée au haut de cette page.</p>
      <p>
        Lorsque des changements importants le nécessitent, nous pouvons également vous en informer dans
        l’application ou par un autre moyen approprié.
      </p>
    </Section>

    <Section heading="13. Droit applicable">
      <p>Les présentes conditions sont régies par les lois applicables au Québec et au Canada.</p>
      <p>
        Aucune disposition des présentes conditions ne limite les droits obligatoires dont un consommateur
        peut bénéficier en vertu des lois applicables.
      </p>
    </Section>

    <Section heading="14. Contact">
      <p>
        Pour toute question concernant VÉLIS ou les présentes conditions : <Email />
      </p>
    </Section>
  </LegalLayout>
);

export default Terms;
